import * as React from 'react';
type IconoAnalisisSanitarioProps = React.SVGProps<SVGSVGElement>;

export const IconoAnalisisSanitario: React.FC<IconoAnalisisSanitarioProps> = (props) => (
	<svg
		width={58}
		height={66}
		viewBox="0 0 58 66"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<path
			d="M0.0595093 8.94281C0.0595093 4.52453 3.64123 0.94281 8.05951 0.94281H47.0595V53.9428L0.0595093 57.9428V8.94281Z"
			fill="#EBF8F0"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.61668 49.9428C3.44297 49.9428 0.0595093 53.3263 0.0595093 57.5C0.0595093 61.6737 3.44297 65.0572 7.61668 65.0572H47.0595V61.8187C45.9619 60.8339 45.2519 59.266 45.2519 57.5C45.2519 55.734 45.9619 54.1661 47.0595 53.1812V49.9428H7.61668Z"
			fill="#EBF8F0"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M7.70713 53.3482C5.38235 53.3482 3.49774 55.2328 3.49774 57.5576C3.49774 59.8824 5.38235 61.767 7.70713 61.767H47.0595V60.9254C46.0014 60.1575 45.317 58.9348 45.317 57.5576C45.317 56.1804 46.0014 54.9577 47.0595 54.1898V53.3482H7.70713Z"
			fill="#7EAE90"
		/>
		<path
			d="M47.0595 12.9428H57.9405L53.5881 19.4714L57.9405 26H47.0595V12.9428Z"
			fill="#FFA692"
		/>
		<path
			d="M10.9203 30.5466L13.0365 23.6209C13.2731 22.8467 14.3554 22.8097 14.6442 23.566L17.2281 30.3311C18.0624 32.5154 16.4494 34.8581 14.1112 34.8581C11.8691 34.8581 10.2652 32.6908 10.9203 30.5466Z"
			stroke="#7EAE90"
			stroke-width="1.70077"
		/>
		<path
			d="M30.4792 30.5466L32.5954 23.6209C32.832 22.8467 33.9142 22.8097 34.2031 23.566L36.787 30.3311C37.6213 32.5154 36.0083 34.8581 33.6701 34.8581C31.428 34.8581 29.824 32.6908 30.4792 30.5466Z"
			stroke="#7EAE90"
			stroke-width="1.70077"
		/>
		<path
			d="M24.0595 17L24.0595 39.11"
			stroke="#7EAE90"
			stroke-width="2.55116"
			stroke-linecap="round"
		/>
		<path
			d="M19.8076 40.3856H28.3114"
			stroke="#7EAE90"
			stroke-width="2.55116"
			stroke-linecap="round"
		/>
		<path
			d="M13.0045 21.6771L34.2642 21.6771"
			stroke="#7EAE90"
			stroke-width="2.55116"
			stroke-linecap="round"
		/>
	</svg>
);

export default IconoAnalisisSanitario;
